import { render, staticRenderFns } from "./commercialListItemFour.vue?vue&type=template&id=4d5b2808"
import script from "./commercialListItemFour.vue?vue&type=script&lang=js"
export * from "./commercialListItemFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports